/* React */
import React, { useState } from "react";

/* Utils */
import SwiperWrapper from "src/utils/wrapper/swiper-wrapper/SwiperWrapper";

/* Components */
import HorizontalBoxplotSlide from "src/components/charts/horizontal-boxplot/horizontal-boxplot-slide/HorizontalBoxplotSlide";

/* Interfaces */
import { SankeyBoxplotProps } from "src/shared/interfaces/charts/SankeyDiagram";

interface HorizontalBoxplotFilterWrapperProps {
  data: SankeyBoxplotProps[];
}

const HorizontalBoxplotFilterWrapper: React.FC<
  HorizontalBoxplotFilterWrapperProps
> = ({ data }) => {
  const [selectedTLs, setSelectedTLs] = useState<string[]>(
    []
  );

  const [activeIndex, setActiveIndes] = useState<number>(0);
  const handleActiveIndex = (index: number) => {
    setActiveIndes(index);
  };

  return (
    <>
      <SwiperWrapper
        data={data}
        handleActiveIndex={handleActiveIndex}
        renderItem={(item, index) => (
          <HorizontalBoxplotSlide
            key={index}
            item={item}
            index={index}
            selectedTLs={selectedTLs}
            handleSelectedTLs={setSelectedTLs}
            activeIndex={activeIndex}
          />
        )}
      />
    </>
  );
};

export default HorizontalBoxplotFilterWrapper;
